import { Component, OnInit } from '@angular/core';
import { APICallService } from 'src/app/services/api-call.service';
import { FormBuilder, Validators, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DatePipe } from '@angular/common';
import { DialogMsgComponent } from '../../common/dialog-msg/dialog-msg.component';
import { FormService } from 'src/app/services/form.service';
import { JsonDataService } from 'src/app/services/json-data.service';
import { AppMessageService } from 'src/app/services/app-message.service';
import { DialogBoxService } from 'src/app/services/dialog-box.service';
import { UserDetailsService } from 'src/app/services/user-details.service';
import { forkJoin, Observable } from 'rxjs';
import { LeaveConfirmation } from '../../common/guard/check.guard';
import { SecurityService } from 'src/app/services/security.service'; 
@Component({
  selector: 'business-code-maintenance',
  templateUrl: './business-code-maintenance.component.html',
  styleUrls: ['./business-code-maintenance.component.css']
})
export class BusinessCodeMaintenanceComponent implements OnInit, LeaveConfirmation {
  
  datePipe = new DatePipe('en-us');

  addDisabled : boolean = false;
  saveDisabled : boolean = true;
  deleteDisabled : boolean = true;
  tranPosted : boolean = false;
  noLoadingInProcess : boolean = true;
  validated : boolean = false;
  userIDReadOnly : boolean = false;
  isLineSelected : boolean = false;
  pubUserStdRatesCodeField: string = '';
  currentUser: string = this.jsonDataService.retrieveFromStorage('userId');
  rowClickedData: any;
  selectedData : any = null;
  moduleId: string = 'BMM187';
  perilDisabled: boolean = true;
  moduleName: string = '';
  tempAddedData: any = [];
  tempUpdateData: any = [];

  businessCodeForm = this.formBuilder.group({
    businessCode: [null, [Validators.required]],
    activeTag: ['A', [Validators.required]],
    businessName: [null, [Validators.required, Validators.maxLength(50)]],
    origBusinessName: [null],
    businessShortDesc:[null],
    businessLongDesc:[null],
    bpimsCode: [null, [Validators.required, Validators.maxLength(8)]],
    bpimsItemCode: [null,  [Validators.maxLength(10)]],
    remarks: [null],
    userID: [null],
    lastUserUpdate: [null]
  });

  constructor(
    private apiCallService: APICallService,
    public _Dialog: MatDialog, 
    private userDetailService: UserDetailsService,
    private formService: FormService, 
    private formBuilder: FormBuilder, 
    private appMessageService: AppMessageService,
    private jsonDataService: JsonDataService,
    private securityService: SecurityService
  ) {
    let moduleLists = JSON.parse(this.jsonDataService.decrypt(sessionStorage.getItem("mdls") || "")); 
    this.moduleName = moduleLists.filter((data: any) => { return data.moduleId === this.moduleId })[0].moduleDesc.toUpperCase();
  }

  canDeactivate(): Observable<boolean> | boolean {
    if(this.tempAddedData!='' || this.tempUpdateData!='') {
      return false;
    } else {
      return true;
    }
  }

  businessCodeTblConfig: any = {
    cols: [
      {
        key: "BUSINESS_CD",
        header: "Business Code",
        dataType: "number",
        width: '15%'
      },
      {
        key: "BUS_NAME",
        header: "Business Name",
        dataType: "string",
        width: '50%'
      },
      {
        key: "BUS_SHORT_DESC",
        header: "Short Description",
        dataType: "string"
      },
      {
        key: "ACTIVE_TAG",
        header: "A",
        dataType: "checkbox",
        width: '10%'
      }
    ],
    tblData: [],
    selection: "single",
    paginator: true,
    rowsPerPage: 10,
    lazy: false,
    totalRecords: 15,
    loading: false,
  }
  ngOnInit() {
    try {
      this.apiCallService.refreshNeeded$
            .subscribe(() => {
              this.getAllBusinessCode();
          });
      this.getAllBusinessCode();
    }
    catch(e) {
    }
  }

  async getAllBusinessCode(){
    try{
      const params = {
        moduleId: this.moduleId,
        userId: this.userDetailService.userId,
        type: "MODULE"
      }
      this.businessCodeTblConfig.loading = true;
      this.apiCallService.getBusinessCode(params).subscribe({
        next: (data: any) => {
          this.securityService.checkRequestKeyResponse(data, ()=>{
            this.securityService.hasValidCsrfToken(data, ()=>{
              data = JSON.parse(this.jsonDataService.decrypt(data.response));
              let rawData:any = [];
              if(!Array.isArray(data)){
                rawData.push(data);
              }
              else{
                rawData = data;
              }
              this.businessCodeTblConfig.tblData = rawData;
              this.businessCodeTblConfig.loading = false;
            });
          })
        },
        error: (e: any) => {
          this.businessCodeTblConfig.loading = false;
        }
      });
    }catch(e){
    }
  }

  updateLine() {
    try {
      this.tranPosted = true;
      this.validateUpdate();
      if (this.validated) {
        this.updateFormTable();
      }
    }
    catch(e) {
    }
  }

  updateFormTable() {
    try {
      let tempInsertChecker = this.tempAddedData.find((line: { BUS_NAME: any }) => 
        line.BUS_NAME.trim().toUpperCase() == this.businessCodeForm.get('origBusinessName')?.value.trim().toUpperCase()
      );
      let tempUpdateChecker = this.tempUpdateData.find((line: { BUS_NAME: any }) => 
        line.BUS_NAME.trim().toUpperCase() == this.businessCodeForm.get('origBusinessName')?.value.trim().toUpperCase()
      );
      
      this.tableDataUpdate();
        
      // Adds Updated Data that exists in the database to an object array for updated datas
      if(tempInsertChecker!=null && tempInsertChecker!='') {
        //this.tempUpdateData.push(this.formValueToData());
        tempInsertChecker.BUSINESS_CD = this.businessCodeForm.get('businessCode')?.value;
        tempInsertChecker.ACTIVE_TAG = this.businessCodeForm.get('activeTag')?.value;
        tempInsertChecker.BUS_NAME = this.businessCodeForm.get('businessName')?.value;
        tempInsertChecker.BUS_SHORT_DESC = this.businessCodeForm.get('businessShortDesc')?.value;
        tempInsertChecker.BUS_LONG_DESC = this.businessCodeForm.get('businessLongDesc')?.value;
        tempInsertChecker.BM_CODE = this.businessCodeForm.get('bpimsCode')?.value;
        tempInsertChecker.BM_ITEM_CODE = this.businessCodeForm.get('bpimsItemCode')?.value;
        tempInsertChecker.REMARKS = this.businessCodeForm.get('remarks')?.value;
        tempInsertChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.businessCodeForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempInsertChecker.USER_ID = this.businessCodeForm.get('userID')?.value;
        tempInsertChecker.MODE = 'I';
      } 
      else if(tempUpdateChecker!=null && tempUpdateChecker!='') {
        tempUpdateChecker.BUSINESS_CD  = this.businessCodeForm.get('businessCode')?.value;
        tempUpdateChecker.ACTIVE_TAG = this.businessCodeForm.get('activeTag')?.value;
        tempUpdateChecker.BUS_NAME = this.businessCodeForm.get('businessName')?.value;
        tempUpdateChecker.BUS_SHORT_DESC = this.businessCodeForm.get('businessShortDesc')?.value;
        tempUpdateChecker.BUS_LONG_DESC = this.businessCodeForm.get('businessLongDesc')?.value;
        tempUpdateChecker.BM_CODE = this.businessCodeForm.get('bpimsCode')?.value;
        tempUpdateChecker.BM_ITEM_CODE = this.businessCodeForm.get('bpimsItemCode')?.value;
        tempUpdateChecker.REMARKS = this.businessCodeForm.get('remarks')?.value;
        tempUpdateChecker.LAST_USER_UPDATE = this.datePipe.transform(new Date(this.businessCodeForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a');
        tempUpdateChecker.USER_ID = this.businessCodeForm.get('userID')?.value;
        tempUpdateChecker.MODE = 'U';
      }
      else {
        this.tempUpdateData.push(this.formValueToData());
      }
      this.saveDisabled = false;
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details updated!", "success");
    }
    catch(e) {
    }
  }

  tableDataUpdate() {
    try {
      this.businessCodeForm.patchValue({
        activeTag: this.businessCodeForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let updateIndex = this.businessCodeTblConfig.tblData.indexOf(this.rowClickedData);
      
      this.businessCodeTblConfig.tblData[updateIndex] = {
        BUSINESS_CD: this.businessCodeForm.get('businessCode')?.value,
        ACTIVE_TAG: this.businessCodeForm.get('activeTag')?.value,
        BUS_NAME: this.businessCodeForm.get('businessName')?.value,
        BUS_SHORT_DESC: this.businessCodeForm.get('businessShortDesc')?.value,
        BUS_LONG_DESC: this.businessCodeForm.get('businessLongDesc')?.value,
        BM_CODE: this.businessCodeForm.get('bpimsCode')?.value,
        BM_ITEM_CODE: this.businessCodeForm.get('bpimsItemCode')?.value,
        REMARKS: this.businessCodeForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.businessCodeForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.businessCodeForm.get('userID')?.value,
        MODE: 'U'
      };
      this.businessCodeTblConfig.tblData = [...this.businessCodeTblConfig.tblData];
    }
    catch(e) {
    }
  }

  formValueToData() {
    try {
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        BUSINESS_CD: this.businessCodeForm.get('businessCode')?.value,
        ACTIVE_TAG: this.businessCodeForm.get('activeTag')?.value,
        BUS_NAME: this.businessCodeForm.get('businessName')?.value,
        BUS_SHORT_DESC: this.businessCodeForm.get('businessShortDesc')?.value,
        BUS_LONG_DESC: this.businessCodeForm.get('businessLongDesc')?.value,
        BM_CODE: this.businessCodeForm.get('bpimsCode')?.value,
        BM_ITEM_CODE: this.businessCodeForm.get('bpimsItemCode')?.value,
        REMARKS: this.businessCodeForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.businessCodeForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.businessCodeForm.get('userID')?.value,
        MODE: 'U'
      }
      return formToData;
    }
    catch(e) {
    }
  }
  deleteLine() {
    try {
      let clickData = this.rowClickedData;
      this.businessCodeTblConfig.tblData = this.businessCodeTblConfig.tblData.filter(
        function(e: any) {
          return e.BUS_NAME.trim().toUpperCase() !== clickData.BUS_NAME.trim().toUpperCase();
        }
      );
      this.tempAddedData = this.tempAddedData.filter(
        function(e: any) {

          return e.BUS_NAME.trim().toUpperCase() !== clickData.BUS_NAME.trim().toUpperCase();
        }
      );
      this.resetFormValues();
    }
    catch(e) {
    }
  }

  insertLine() {
    try {
      this.tranPosted = true;
      this.validateInsert();
      if (this.validated) {
        this.addFormToTable();
      }
    }
    catch(e) {
    }
  }
  addFormToTable() {
    try {
      this.businessCodeForm.patchValue({
        activeTag: this.businessCodeForm.get('activeTag')?.value,
        userID: this.currentUser,
        lastUserUpdate: new Date()
      });
      let formToData: any = { // this.datePipe.transform(new Date(), 'MM/dd/yyyy')
        BUSINESS_CD: this.businessCodeForm.get('businessCode')?.value,
        BUS_NAME: this.businessCodeForm.get('businessName')?.value,
        BUS_SHORT_DESC: this.businessCodeForm.get('businessShortDesc')?.value,
        BUS_LONG_DESC: this.businessCodeForm.get('businessLongDesc')?.value,
        BM_ITEM_CODE: this.businessCodeForm.get('bpimsItemCode')?.value,
        ACTIVE_TAG: this.businessCodeForm.get('activeTag')?.value,
        BM_CODE: this.businessCodeForm.get('bpimsCode')?.value,
        REMARKS: this.businessCodeForm.get('remarks')?.value,
        LAST_USER_UPDATE: this.datePipe.transform(new Date(this.businessCodeForm.get('lastUserUpdate')?.value), 'MM/dd/YYYY h:mm:ss a'),
        USER_ID: this.businessCodeForm.get('userID')?.value,
        MODE: 'I'
      }
      this.businessCodeTblConfig.tblData.unshift(formToData);
      this.businessCodeTblConfig.tblData = [...this.businessCodeTblConfig.tblData];
      this.tempAddedData.push(formToData);
      this.resetFormValues();
      this.appMessageService.showAppMessage("Standard Rates details added!", "success");
    }
    catch(e) {
    }
  }

  saveData(tempChangeData:any[]){
    this.apiCallService.saveBusinessCode(tempChangeData)
    .subscribe({
      next: (response : any) => {
        this.securityService.checkRequestKeyResponse(response, () => {
          this.securityService.hasValidCsrfToken(response, ()=>{
            if (response.status == "SUCCESS" && this.tranPosted) {
              this.openDialog('SUCCESS', 'Details Successfully saved!');
              this.getAllBusinessCode();
              this.resetFormValues();
              this.tempAddedData = [];
              this.tempUpdateData = [];
              this.saveDisabled = this.saveChecker();
            }  
            else {
              this.getAllBusinessCode();
              this.saveDisabled = this.saveChecker();
              this.openDialog('ERROR', 'An error has occured while saving details');
            }
          });
        });
      }, 
      error: () => {
        this.openDialog('ERROR', 'An error has occured while saving details');
      }
    });
  }

  toSave() {
    try {
      this.noLoadingInProcess = false;
      this.formService.showFormLoader(null, "generate-line-form", "Please wait ...", null, null);
      let tempChangeData= this.tempAddedData.concat(this.tempUpdateData);
      if(tempChangeData.length!=0) {
        this.saveData(tempChangeData);
      } else {
        this.getAllBusinessCode();
        this.resetFormValues();
        this.tempAddedData = [];
        this.tempUpdateData = [];
        this.saveDisabled = this.saveChecker();
      }
    }
    catch(e) {
    }
  }
  saveChecker() {
    try {
      if((this.tempAddedData==null || this.tempAddedData=='') && (this.tempUpdateData==null || this.tempUpdateData=='')) {
        return true;
      }
      else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  deleteChecker(ev: any) {
    try {
      let tempDataFlag;
      tempDataFlag = this.tempAddedData.filter(function(e: any) {
        let returnValue = e.BUSINESS_CD==ev.BUSINESS_CD;
        return returnValue;
      });
      if(tempDataFlag==''||tempDataFlag==null) {
        return true;
      } else {
        return false;
      }
    }
    catch(e) {
      return true;
    }
  }

  onRowClick(ev: any) {
    try {    
      if(ev!=null) {
        this.rowClickedData = ev;
        this.loadFormValues();
        this.saveDisabled = this.saveChecker();
        this.deleteDisabled = this.deleteChecker(ev);
      }
      else {
        this.resetFormValues();
      }
    }
    catch(e) {
    }
  }

  loadFormValues() {
    try {
      this.businessCodeForm.patchValue({
        businessCode: this.rowClickedData.BUSINESS_CD,
        activeTag: this.rowClickedData.ACTIVE_TAG,
        businessName: this.rowClickedData.BUS_NAME,
        origBusinessName: this.rowClickedData.BUS_NAME,
        businessShortDesc: this.rowClickedData.BUS_SHORT_DESC,
        businessLongDesc: this.rowClickedData.BUS_LONG_DESC,
        bpimsCode: this.rowClickedData.BM_CODE,
        bpimsItemCode: this.rowClickedData.BM_ITEM_CODE,
        remarks: this.rowClickedData.REMARKS,
        userID: this.rowClickedData.USER_ID,
        lastUserUpdate: this.rowClickedData.LAST_USER_UPDATE
      });
      this.addDisabled = true;
      this.userIDReadOnly = true;
      this.isLineSelected = true;
    }
    catch(e) {
    }
  }

  resetFormValues() {
    try {
      this.selectedData = null;
      // this.paramForm.get('lineCD')?.enable();
      this.businessCodeForm.patchValue({
        businessCode: null,
        activeTag: 'A',
        businessName: null,
        origBusinessName: null,
        businessShortDesc: null,
        businessLongDesc: null,
        bpimsCode: null,
        bpimsItemCode: null,
        remarks: null,
        userID: null,
        lastUserUpdate: null
      });

      this.addDisabled = false;
      this.saveDisabled = this.saveChecker();
      this.deleteDisabled = true;
      this.userIDReadOnly = false;
      this.isLineSelected = false;

      this.rowClickedData = '' || null;
    }
    catch (e) {
    console.error(e);
    }
  }

  openDialog(title: any, message: any) {
    try {
      this.noLoadingInProcess = true;
      this.formService.hideFormLoader("generate-line-form");
      this._Dialog.open(DialogMsgComponent, { 
        disableClose: true,
        width: "500px",
        data: {
          title: title,
          content: message
        } 
      });
    } catch(e) {
    }
  }

  validateInsert() {
    try {
      this.validated = false;
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                           //10 secs countdown
          this.formService.hideFormMsg("business-code-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(this.businessCodeTblConfig.tblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("business-code-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }

  requiredFieldCheck() {
    try {
      if(this.businessCodeForm.get('activeTag')?.value==='' || this.businessCodeForm.get('activeTag')?.value===null 
        || this.businessCodeForm.get('businessName')?.value.trim()==='' || this.businessCodeForm.get('businessName')?.value===null
        || this.businessCodeForm.get('businessShortDesc')?.value.trim()==='' || this.businessCodeForm.get('businessShortDesc')?.value===null
        || this.businessCodeForm.get('businessLongDesc')?.value.trim()==='' || this.businessCodeForm.get('businessLongDesc')?.value===null) {
        this.formService.showFormMsg("business-code-error-message", 'There are missing information. Please provide the necessary information needed.', "E");
        return false;
      }
      else {
        return true;
      }
   }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  duplicateCheck(tblData:any) {
    try {
      let fieldBusinessName = this.businessCodeForm.get('businessName')?.value;
      this.pubUserStdRatesCodeField = tblData.filter(function(e: any) {
        if(e.BUS_NAME.trim().toUpperCase()==fieldBusinessName.trim().toUpperCase()){
          return true
        }
        else{
          return false
        }
      });
      if(this.pubUserStdRatesCodeField=='' || this.pubUserStdRatesCodeField==null) {
        return true;
      } else {
        this.formService.showFormMsg("business-code-error-message", 'Business Name already exists. Please add a unique Business Name', "E");
        return false;
      }
    }
    catch (e) {
    console.error(e);
      return false;
    }
  }
  validateUpdate() {
    try {
      this.validated = false;
      let fieldBusinessName = this.businessCodeForm.get('origBusinessName')?.value;
      let filteredTblData = this.businessCodeTblConfig.tblData.filter(function(e:any){
        if(e.BUS_NAME.trim().toUpperCase()==fieldBusinessName.trim().toUpperCase()){
          return false;
        }
        else{
          return true;
        }
      });
      if (!this.requiredFieldCheck()){
        setTimeout(()=>{                          
          this.formService.hideFormMsg("business-code-error-message");
        }, 10000);
      }
      else if (!this.duplicateCheck(filteredTblData)) {
        setTimeout(()=>{                           
          this.formService.hideFormMsg("business-code-error-message");
        }, 10000);
      }
      else {
        this.validated = true;
      }
    }
    catch (e) {
    console.error(e);
    }
  }
  
}
